import Button from "./Button";
import Logo from "../assets/logo.png";
import Modal from "./Modal";
import { useEffect, useState } from "react";
import { FaBars, FaTwitch, FaTwitter } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import TwitterLogo from "../assets/xLogowhite.png";

const Header: React.FC = () => {
  const [mobNavOpen, setMobNavOpen] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(window.scrollY);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const navbarId = 'navbar';

      const navbar = document.getElementById(navbarId);

      if (prevScrollPos > currentScrollPos) {
        // Scrolling up
        // @ts-ignore: Object is possibly 'null'.
       navbar.style.top = "0";
      } else {
        // Scrolling down
        // @ts-ignore: Object is possibly 'null'.
        navbar.style.top = "-100%"; // Adjust the value
      }

      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);

  return (
    <>
      <Modal
        className={"w-full"}
        isOpen={mobNavOpen}
        onClose={() => setMobNavOpen(!mobNavOpen)}
      >
        <div className="space-y-8 ">
          <ul className="flex flex-col gap-4 items-center justify-center">
            <li
              onClick={() => setMobNavOpen(!mobNavOpen)}
              className="transition-all ease-in-out text-lg hover:text-black"
            >
              <a href="#home">HOME</a>
            </li>
            <li
              onClick={() => setMobNavOpen(!mobNavOpen)}
              className="transition-all ease-in-out text-lg hover:text-black"
            >
              <a href="#howtobuy">How to Buy</a>
            </li>
            <li
              onClick={() => setMobNavOpen(!mobNavOpen)}
              className="transition-all ease-in-out text-lg hover:text-black"
            >
              <a href="#about">About Us</a>
            </li>
            <li
              onClick={() => setMobNavOpen(!mobNavOpen)}
              className="transition-all ease-in-out text-lg hover:text-black"
            >
              <a href="#utilities">UTILITIES</a>
            </li>
            <li
              onClick={() => setMobNavOpen(!mobNavOpen)}
              className="transition-all ease-in-out text-lg hover:text-black"
            >
              <a href="#whyus">Why Us</a>
            </li>
          </ul>

          <Button
            onClick={() => setMobNavOpen(!mobNavOpen)}
            className={"text-center w-fit mx-auto bg-[black] text-white"}
          >
            BUY NOW
          </Button>
          <div>
            <img
              src={TwitterLogo}
              alt=""
              className="w-12 mx-auto cursor-pointer"
            />
          </div>
        </div>
      </Modal>
      {/* prevScrollPos > currentScrollPos */}
      <div
        id="navbar"
        className="navbar w-full z-50 fixed left-1/2 -translate-x-1/2  md:px-0"
      >
        <div className=" flex items-center justify-between mx-auto  px-4 md:px-16 py-4 text-black ">
          <a href="#home">
            <div className="flex items-center gap-2">
              <img src={Logo} alt="" className="h-12 cursor-pointer" />
              <span className="text-xl uppercase font-bold text-primary">
                Elephonk
              </span>
            </div>
          </a>
          <div>
            <ul className="hidden md:flex gap-4 items-center justify-center uppercase">
              <li className="transition-all ease-in-out text-lg hover:text-primary">
                <a href="#home">HOME</a>
              </li>
              <li className="transition-all ease-in-out text-lg hover:text-primary">
                <a href="#howtobuy">How to Buy</a>
              </li>
              <li className="transition-all ease-in-out text-lg hover:text-primary">
                <a href="#about">About Us</a>
              </li>
              <li className="transition-all ease-in-out text-lg hover:text-primary">
                <a href="#utilities">UTILITIES</a>
              </li>
              <li className="transition-all ease-in-out text-lg hover:text-primary">
                <a href="#whyus">Why Us</a>
              </li>
            </ul>
          </div>
          <div className="flex gap-4 items-center">
            <a href="#home">
              <Button
                className={"bg-primary shadow-md text-white hidden md:block "}
              >
                BUY NOW
              </Button>
            </a>
            {/* <FaTwitter /> */}
            <div>
              <a href="www.twitter.com" target="_blank">
                <img
                  src={TwitterLogo}
                  alt=""
                  className="w-10 hidden md:block cursor-pointer"
                />
              </a>
            </div>

            <div className="md:hidden">
              {mobNavOpen ? (
                <AiOutlineClose
                  onClick={() => setMobNavOpen(!mobNavOpen)}
                  className="cursor-pointer  text-2xl"
                />
              ) : (
                <FaBars
                  onClick={() => setMobNavOpen(!mobNavOpen)}
                  className="cursor-pointer  text-2xl"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
